// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3593":"122eb948","3612":"122eb948","3992":"f9f78dc0","4570":"882673c9","6917":"122eb948","9205":"122eb948"}[chunkId] + ".chunk.css";
};